var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canEdit)?_c('gli-btn',_vm._g(_vm._b({},'gli-btn',_vm.$attrs,false),_vm.$listeners),[[_vm._t("default")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }